<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Impuestos y servicios</b-card-header>
      <b-card-body>
        <form-wizard color="#ff5955" backButtonText="Atras" ref="wizard" title subtitle :hide-buttons="true">
          <template slot="step" scope="props">
            <wizard-step :tab="props.tab" :transition="props.transition" :index="props.index"></wizard-step>
          </template>
          <tab-content title="Modo de ingreso" icon="fa fa-fw fa-clipboard-list">
            <div class="text-center">
              <base-button
                type="danger"
                size="lg"
                @click="barras"
                style="margin-top: 10px"
              >Codigo de barras</base-button>
            </div>
            <div class="text-center">
              <base-button
                type="danger"
                size="lg"
                @click="manual"
                style="margin-top: 10px"
              >Ingreso manual</base-button>
            </div>
          </tab-content>
          <tab-content title="Seleccionar empresa" icon="fa fa-fw fa-store" v-if="ingresoManual">
            <div class="row">
              <div class="col-md-12">
                <base-input
                  class="input-group-alternative mb-3"
                  placeholder="Buscar..."
                  addon-left-icon="fa fa-fw fa-search"
                  @keyup="buscarCompania()"
                  v-model="textCompania"
                ></base-input>
              </div>
            </div>
            <div
              class="row"
              v-for="(item,indexart) in companias"
              @click="companiaClicked(item)"
              v-bind:key="indexart"
              :value="item.EntityID"
              style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
            >
              <div class="col-10">
                <div style="margin-left: 10px;">
                  <div>
                    <!-- <i
                      style="font-size: 30px; color: #ff5955; vertical-align: middle"
                      class="fa fa-fw fa-store"
                    ></i>-->
                    <img
                      src="/img/portal/rubros/ic_menu_home_impuesto.png"
                      style="width30px;height:30px;"
                    />
                    <span style="vertical-align: middle; margin-left: 10px;">{{item.CompanyDesc}}</span>
                  </div>
                </div>
              </div>
              <div class="col-2 text-right" style="padding-right: 25px">></div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <base-button type="danger" size="lg" @click="atras" style="margin-top: 10px">Atras</base-button>
              </div>
            </div>
          </tab-content>
          <tab-content title="Seleccione Modalidad" icon="fas fa-map-signs" v-if="ingresoManual">
            <div
              class="row"
              v-for="(item,indexmod) in modalities"
              @click="modalityClicked(item)"
              v-bind:key="indexmod"
              :value="item.EntityID"
              style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
            >
              <div class="col-10">
                <div style="margin-left: 10px;">
                  <div>
                    <!-- <i
                      style="font-size: 30px; color: #ff5955; vertical-align: middle"
                      class="fa fa-fw fa-store"
                    ></i>-->
                    <img
                      src="/img/portal/rubros/ic_menu_home_impuesto.png"
                      style="width30px;height:30px;"
                    />
                    <span style="vertical-align: middle; margin-left: 10px;">{{item.Desc}}</span>
                  </div>
                </div>
              </div>
              <div class="col-2 text-right" style="padding-right: 25px">></div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <base-button type="danger" size="lg" @click="atras" style="margin-top: 10px">Atras</base-button>
              </div>
            </div>
          </tab-content>
          <tab-content title="Ingreso de factura" icon="fa fa-fw fa-file-invoice-dollar">
            <RapiPagoManualControl v-bind:items="ingresosmanuales" v-if="ingresosmanuales.length>0"></RapiPagoManualControl>
            <div class="row" v-else>
              <div class="col-md-12">
                <label>Codigo de barras</label>
                <base-input v-model="codigobarras"></base-input>
              </div>
            </div>

            <div
              class="row"
              v-for="(item,indexart) in companiasConfilictoBarra"
              @click="seleccionarCompaniaConflicto(item)"
              v-bind:key="indexart"
              :value="item.EntityID"
              style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
            >
              <div class="col-10">
                <div style="margin-left: 10px;">
                  <div>
                    <!-- <i
                      style="font-size: 30px; color: #ff5955; vertical-align: middle"
                      class="fa fa-fw fa-store"
                    ></i>-->
                    <img
                      src="/img/portal/rubros/ic_menu_home_impuesto.png"
                      style="width30px;height:30px;"
                    />
                    <span style="vertical-align: middle; margin-left: 10px;">{{item.companyDesc}}</span>
                  </div>
                </div>
              </div>
              <div class="col-2 text-right" style="padding-right: 25px">></div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <base-button type="danger" size="lg" @click="atras" style="margin-top: 10px">Atras</base-button>
                <base-button
                  type="success"
                  size="lg"
                  @click="validarFactura"
                  v-if="ingresosmanuales.length>0"
                  style="margin-top: 10px"
                >Siguiente</base-button>
                <base-button
                  type="success"
                  size="lg"
                  @click="validarCodigoBarra"
                  v-else
                  style="margin-top: 10px"
                >Siguiente</base-button>
              </div>
            </div>
          </tab-content>

          <tab-content title="Selección de factura" icon="fa fa-fw fa-hand-pointer">
            <div class="row">
              <div
                class="col-md-12 text-center"
                style="color: #ff5955; font-size: 30px"
              >{{compania.CompanyDesc}}</div>
            </div>
            <div
              class="row"
              v-for="(item,indexfact) in facturas"
              v-bind:key="indexfact"
              :value="item.barra"
              style="padding: 5px; border-bottom: 1px solid #d6d4d4; margin-right: 0; margin-left: 0"
            >
              <div class="col-10">
                <div style="margin-left: 10px; display: flex">
                  <div style="margin-right: 20px;">{{item.other}}. Importe a pagar</div>
                  <vue-numeric
                    currency="$"
                    v-bind:precision="2"
                    decimal-separator="."
                    thousand-separator=" "
                    v-model="item.a_pagar"
                    class="form-control"
                    style="max-width: 200px"
                    v-if="item.canModify"
                  ></vue-numeric>
                  <span v-else>${{item.a_pagarSTR}}</span>
                </div>
              </div>
              <div class="col-2 text-right" style="padding-right: 25px">
                <base-button type="danger" size="sm" @click="onPagarFactura(item)">
                  <i class="fa fa-file-invoice-dollar fa-fw"></i>Pagar
                </base-button>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <base-button type="danger" size="lg" @click="atras" style="margin-top: 10px">Atras</base-button>
              </div>
            </div>
          </tab-content>

          <tab-content title="Resultado" icon="fa fa-fw fa-flag">
            <div class="row">
              <div class="col-md-12">
                <base-alert :type="resultado.Tipo">
                  <span class="alert-inner--icon">
                    <i :class="resultado.Icono"></i>
                  </span>
                  <span class="alert-inner--text" v-html="resultado.Texto"></span>
                </base-alert>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-center">
                <base-button
                  type="success"
                  size="lg"
                  @click="nuevoPago"
                  style="margin: auto; margin-top: 10px"
                >
                  <i class="fa fa-plus fa-fw"></i>Iniciar nuevo pago
                </base-button>
              </div>
            </div>
          </tab-content>
        </form-wizard>
      </b-card-body>
    </b-card>
    <pin-validation ref="pin-validation"
      :showModal.sync="showModalPinValidation"
      v-on:validPin="onValidPin"
      v-on:loadUsePaymentPin="onLoadUsePaymentPin">
    </pin-validation>
  </div>
</template>

<script>
// ******************** Select ********************//
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import RapiPagoManualControl from "@/components/Specific/RapipagoManualControl";

import { FormWizard, TabContent, WizardStep } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import PinValidation from '@/views/Pin/PinValidation';

export default {
  components: {
    FormWizard,
    TabContent,
    WizardStep,
    RapiPagoManualControl,
    "pin-validation": PinValidation
  },
  data() {
    return {
      ingresoManual: true,
      companiasConfilictoBarra: [],
      companias: [],
      facturas: [],
      modalities: [],
      modality: null,
      textCompania: "",
      compania: {},
      ingresosmanuales: [],
      codigobarras: "",
      validacionfacturas: { Bills: [] },
      resultado: { Icono: "", Texto: "", Tipo: "" },
      controls:[],
      usePaymentPin: false,
      showModalPinValidation: false,
      itemPagarFactura: null
    };
  },
  methods: {
    manual() {
      this.inicializar(this);
      this.ingresoManual = true;
      this.$refs.wizard.nextTab();
    },
    barras() {
      this.inicializar(this);
      this.ingresoManual = false;
      this.$refs.wizard.changeTab(0, 3);
    },
    modalityClicked(item) {
      let context = this;
      context.modality = item;

      axiosHelpers.axiosGet(
        "RapiPago/GetForm",
        { ModalityID: context.modality.ModNumber },
        context,
        function(data) {
          context.controls=[];
          data.ResponseVM.Fields.forEach(function(element, index) {
            var newElement = data.ResponseVM.Fields[index];
            if (
              element.visualElementType == "TEXT_FIELD" ||
              element.visualElementType == "HIDDEN_TEXT_FIELD"
            ) {
              if (element.visualElementType == "HIDDEN_TEXT_FIELD") {
                newElement.typeText = "password";
              } else {
                newElement.typeText = "text";
              }
            }
            context.controls.push(newElement);
          });
          context.ingresosmanuales = context.controls;

          if (context.ingresosmanuales.length == 0) {
            notificationHelpers.showError(
              "Error",
              "No se encontraron datos para ingreso manual",
              context
            );
          } else {
            context.$refs.wizard.nextTab();
          }
        }
      );
    },
    async companiaClicked(item) {
      let context = this;
      context.compania = item;
      context.modalities = item.Modalities;
      context.$refs.wizard.nextTab();
    },
    buscarCompania() {
      let context = this;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        if (context.textCompania != null && context.textCompania.length >= 3) {
          axiosHelpers.axiosGet(
            "RapiPago/GetCompanies",
            { CompanyFilter: context.textCompania },
            context,
            function(data) {
              context.companias = data.ResponseVM.Companies;
            }
          );
        }
      }, 800);
    },
    validarCodigoBarra() {
      let context = this;

      if (context.codigobarras == "") {
        notificationHelpers.showError(
          "Advertencia!",
          "Debe completar el código de barras",
          this
        );

        return;
      }

      axiosHelpers.axiosGet(
        "RapiPago/CheckPayment",
        {
          Barcode: context.codigobarras
        },
        context,
        function(data) {
          if (data.ResponseVM.Bills.length == 0) {
            notificationHelpers.showError(
              "Error",
              "No se encontraron facturas para el codigo de barras",
              context
            );
          } else {
            context.filtrarCompaniasCodigoBarra(data.ResponseVM.Bills, context);
          }
        }
      );
    },
    validarFactura() {
      let ingresosValidos = false;
      var formData = [];
      if (this.ingresosmanuales.length > 0) {
        for (var i = 0; i < this.ingresosmanuales.length; i++) {

            if (
              this.ingresosmanuales[i].valor != null &&
              this.ingresosmanuales[i].valor != ""
            ) {
              ingresosValidos = true;

              formData.push({
                FormKey: this.ingresosmanuales[i].name,
                FormValue: this.ingresosmanuales[i].valor
              });
            } else {
              ingresosValidos = false;
              formData = [];
              break;
            }
          
        }
      }
      if (this.codigobarras == "" && ingresosValidos == false) {
        notificationHelpers.showError(
          "Advertencia!",
          "Debe completar el código de barras o los ingresos manuales",
          this
        );
        return;
      }

      let context = this;
      axiosHelpers.axiosPost(
        "RapiPago/GetGrid",
        {
          ModalityID: context.modality.ModNumber,
          FormValues: formData
        },
        context,
        function(data) {
          if (
            data.ResponseVM.GridValues != null &&
            data.ResponseVM.GridValues.length > 0
          ) {
            context.mapArray(data.ResponseVM.GridValues, context);
            context.validacionfacturas = data.ResponseVM;
            context.$refs.wizard.nextTab();
          } else {
            if (data.Alerts == null || data.Alerts.length == 0) {
              notificationHelpers.showWarning(
                "Advertencia!",
                "No se encontraron facturas para cobrar",
                context
              );
            }
          }
        }
      );
    },
    onPagarFactura(item) {
      let context = this;

      context.itemPagarFactura = item;
      context.validate(item);
    },
    validate(item) {
      let context = this;

      if (context.modality == null) {
        context.modality = {
          ModNumber: item.modalityId
        };
      }

      var modifyImport = context.canModifyImport(item);

      if (!modifyImport.CanModify && item.a_pagar != item.a_pagar_original) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "El importe ingresado no es valido",
          context
        );
        return;
      }
      if (
        modifyImport.CanModifyOnlyLargeAmount &&
        item.a_pagar < item.a_pagar_original
      ) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "El importe ingresado debe ser mayor a " + item.a_pagar_original,
          context
        );
        return;
      }

      if (
        modifyImport.CanModifyOnlyMinorAmount &&
        item.a_pagar > item.a_pagar_original
      ) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "El importe ingresado debe ser menor a " + item.a_pagar_original,
          context
        );
        return;
      }

      if (
        modifyImport.UseLimits &&
        context.compania.Limits != undefined &&
        context.compania.Limits != null
      ) {
        var limit = context.compania.Limits;

        if (
          item.a_pagar < limit.minPositive ||
          item.a_pagar > limit.maxPositive
        ) {
          notificationHelpers.showWarning(
            "Advertencia!",
            "El importe ingresado debe estar entre " +
              limit.minPositive +
              " y " +
              limit.maxPositive,
            context
          );
          return;
        }
      }

      context.pinValidate();
    },
    pagarFactura() {
      let context = this;
      let item = context.itemPagarFactura;

      var req = {
        barcode: item.barra,
        amount: item.a_pagar,
        companyCode: context.compania.CompanyNumber,
        companyDesc: context.compania.CompanyDesc,
        document: "",
        modalityId: context.modality.ModNumber,
        deviceID: "",
        isAndroid: false
      };

      axiosHelpers.axiosPost("RapiPago/Payment", req, context, function(data) {
        if (data.Alerts.length == 0) {
          if (data.ResponseVM.Success) {
            let msg =
              "El pago se realizó satisfactoriamente" +
              "<br/>" +
              " Número de transacción: " +
              data.ResponseVM.IdTrx +
              "<br/>";

            context.resultado = {
              Texto: msg,
              Tipo: "success",
              Icono: "fa fa-fw fa-thumbs-up"
            };
            context.$refs.wizard.nextTab();
          } else if (data.ResponseVM.Rejected) {
            context.resultado = {
              Texto: "La operacón fue rechazada",
              Tipo: "danger",
              Icono: "fa fa-fw fa-thumbs-down"
            };
            context.$refs.wizard.nextTab();
          } else {
            context.resultado = {
              Texto:
                "La operación esta demorando mas de lo normal, te avisaremos cuando este el resultado final de la operación",
              Tipo: "warning",
              Icono: "fa fa-fw fa-clock"
            };
            context.$refs.wizard.nextTab();
          }
        } else {
          context.resultado = {
            Texto: data.Alerts[0].Message,
            Tipo: "danger",
            Icono: "fa fa-fw fa-thumbs-down"
          };
          context.$refs.wizard.nextTab();
        }
      });
    },
    atras() {
      this.$refs.wizard.prevTab();
    },
    nuevoPago() {
      let context = this;

      context.inicializar(context);

      this.$refs.wizard.reset();
    },
    inicializar(context) {
      context.ingresoManual = true;
      context.companiasConfilictoBarra = [];
      context.companias = [];
      context.facturas = [];
      context.modalities = [];
      context.modality = null;
      context.textCompania = "";
      context.compania = {};
      context.ingresosmanuales = [];
      context.codigobarras = "";
      context.validacionfacturas = { Bills: [] };
      context.resultado = { Icono: "", Texto: "", Tipo: "" };
      context.itemPagarFactura = null
    },
    mapArray(items, context) {
      var objetos = [];
      for (var i = 0; i < items.length; i++) {
        var preObj = {};
        preObj.other = "";
        for (var j = 0; j < items[i].length; j++) {
          var element = items[i][j];

          switch (element.FieldCod) {
            case "barra":
              preObj.barra = element.FieldValue;
              break;
            case "NRF":
              preObj.NRF = element.FieldValue;
              break;
            case "DAF":
              preObj.DAF = element.FieldValue;
              break;
            case "codTI":
              preObj.codTI = element.FieldValue;
              break;
            case "descTI":
              preObj.descTI = element.FieldValue;
              break;
            case "a_pagar":
              preObj.a_pagar = element.FieldValue;
              preObj.a_pagar_original = element.FieldValue;
              preObj.a_pagarSTR = Number(preObj.a_pagar).toFixed(2);
              break;
            default:
              preObj.other += " " + element.FieldValue;
              break;
          }
        }
        preObj.other = preObj.other.trim();
        var result = context.canModifyImport(preObj);
        preObj.canModify = result.CanModify;
        objetos.push(preObj);
      }
      context.facturas = objetos;
    },
    canModifyImport(item) {
      var Result = {};
      Result.CanModify = false;
      Result.CanModifyOnlyLargeAmount = false;
      Result.CanModifyOnlyMinorAmount = false;
      Result.UseLimits = false;
      Result.CanModifyOnlyIsZero = false;

      switch (item.codTI) {
        case "CAC":
          if (item.a_pagar == 0) {
            Result.CanModifyOnlyIsZero = true;
            Result.CanModify = true;
          }
          break;
        case "ESC":
          // -- En este caso vuelve todo Default
          break;
        case "SAB":
          Result.CanModify = true;
          Result.UseLimits = true;
          break;
        case "SLI":
          Result.CanModify = true;
          Result.CanModifyOnlyLargeAmount = true;
          Result.UseLimits = true;
          break;
        case "SLS":
          Result.CanModify = true;
          Result.CanModifyOnlyMinorAmount = true;
          Result.UseLimits = true;
          break;
        default:
          break;
      }

      return Result;
    },
    filtrarCompaniasCodigoBarra(facturas, context) {
      const result = [];
      const map = new Map();
      for (const item of facturas) {
        if (!map.has(item.companyNumber)) {
          map.set(item.companyNumber, true);
          var itemComp = {
            companyNumber: item.companyNumber,
            companyDesc: item.companyDesc,
            Limits: item.Limits,
            bills: []
          };

          var factura = {
            barra: item.barcode,
            paymentType: item.paymentType,
            codTI: item.typeOfAmount,
            typeOfAmountDesc: item.typeOfAmountDesc,
            a_pagar: item.amount,
            a_pagar_original: item.amount,
            a_pagarSTR: Number(item.amount).toFixed(2),
            other: item.barcode,
            modalityDesc: item.modalityDesc,
            modalityId: item.modalityId
          };
          var resultnew = context.canModifyImport(factura);
          factura.canModify = resultnew.CanModify;

          itemComp.bills.push(factura);

          result.push(itemComp);
        } else {
          var element = result.find(
            x => x.companyNumber == itemComp.companyNumber
          );
          result.pop(element);

          var factura = {
            barra: item.barcode,
            paymentType: item.paymentType,
            codTI: item.typeOfAmount,
            typeOfAmountDesc: item.typeOfAmountDesc,
            a_pagar: item.amount,
            a_pagar_original: item.amount,
            a_pagarSTR: Number(item.amount).toFixed(2),
            other: item.barcode,
            modalityDesc: item.modalityDesc,
            modalityId: item.modalityId
          };

          var resultOld = context.canModifyImport(factura);
          factura.canModify = resultOld.CanModify;

          element.bills.push(factura);
          result.push(element);
        }
      }
      context.companiasConfilictoBarra = result;

      if (context.companiasConfilictoBarra.length == 1) {
        context.facturas = context.companiasConfilictoBarra[0].bills;
        context.compania = {
          CompanyNumber: context.companiasConfilictoBarra[0].companyNumber,
          CompanyDesc: context.companiasConfilictoBarra[0].companyDesc,
          Limits: context.companiasConfilictoBarra[0].Limits
        };
        context.$refs.wizard.nextTab();
      }
    },
    seleccionarCompaniaConflicto(item) {
      let context = this;
      context.facturas = item.bills;
      context.compania = {
        CompanyNumber: item.companyNumber,
        CompanyDesc: item.companyDesc,
        Limits: item.Limits
      };
      context.$refs.wizard.nextTab();
    },
    onValidPin(val) {
      let context = this;

      if(val) {
        context.pagarFactura();
      }
    },
    onLoadUsePaymentPin(val) {
      let context = this;

      context.usePaymentPin = val;
    },
    pinValidate() {
      let context = this;

      if(context.usePaymentPin) {
        context.showModalPinValidation = true;
      } else {
        context.pagarFactura();
      }
    }
  },
  beforeMount: function() {
    // let context = this;

    // axiosHelpers.axiosGet(
    //   "BillPayment/GetCobroExpressCategories",
    //   {},
    //   this,
    //   function(data) {
    //     context.rubros = data.ResponseVM;
    //   }
    // );
  }
};
</script>